
export const LICENSE_TYPE_OPTIONS = [
    {value: 'Enterprise Starter', label: 'Enterprise Starter', id:1},
    {value: 'Enterprise Standard', label: 'Enterprise Standard', id: 2},
    {value: 'Frontline Starter', label: 'Frontline Starter', id:3}
];

type RoleOptions = {
    [key: string]: Array<{
    value: string; 
    label: string
    }>
}
export const ROLE_OPTIONS: RoleOptions = {
    'Enterprise Starter': [
        {value: 'organizer', label: 'organizer'},
        {value: 'fileOrganizer', label: 'fileOrganizer'},
         {value: 'writer', label: 'writer'} 
        ],

        'Enterprise Standard': [
        {value: 'organizer', label: 'organizer'},
        {value: 'fileOrganizer', label: 'fileOrganizer'},
         {value: 'writer', label: 'writer'} 
        ],

        'Frontline Starter': [
        {value: 'writer', label: 'writer'}
        ],

}

export const PERM_TYPE =[
    {value: 'group', label: 'group'},
    {value: 'user', label: 'user'},
]